import CompanyEventRegistration from './CompanyEventRegistration';

export default CompanyEventRegistration;
